import { gql } from "@apollo/client";

export const GET_OWNER_BRIEF = gql`
  query GetOwnerBrief($date: String) {
    getOwnerBrief(date: $date) {
      status
      message
      data
    }
  }
`;

const SETTINGS = `
  status
  message
  settings {
    enabled
    emails
    pushAdminIds
  }
  admins {
    id
    fullName
    hasDevice
  }
`;

export const GET_OWNER_BRIEF_SETTINGS = gql`
  query GetOwnerBriefSettings {
    getOwnerBriefSettings { ${SETTINGS} }
  }
`;

export const UPDATE_OWNER_BRIEF_SETTINGS = gql`
  mutation UpdateOwnerBriefSettings($data: OwnerBriefSettingsInput!) {
    updateOwnerBriefSettings(data: $data) { ${SETTINGS} }
  }
`;

export const SEND_OWNER_BRIEF_NOW = gql`
  mutation SendOwnerBriefNow($date: String) {
    sendOwnerBriefNow(date: $date) {
      status
      message
    }
  }
`;
